<template>
  <div class="row">
    <div class="col-12">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccountHomeAddCompany',
};
</script>
